import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft, ShieldCheck, FileText, Megaphone, IdentificationCard } from '@phosphor-icons/react';

const API = process.env.REACT_APP_BACKEND_URL;
const imageUrl = (path) => `${API}/api/public/files/${path}`;

export default function InformacaoLegalPage() {
  const navigate = useNavigate();
  const [legal, setLegal] = useState(null);

  useEffect(() => {
    axios.get(`${API}/api/public/site-content`).then(({ data }) => setLegal(data.legal_info)).catch(() => {});
  }, []);

  return (
    <div className="space-y-5" data-testid="informacao-legal-page">
      <button onClick={() => navigate(-1)} className="flex items-center gap-1.5 text-sm text-brand-muted hover:text-brand-green" data-testid="informacao-legal-back-btn">
        <ArrowLeft size={16} /> Voltar
      </button>
      <h1 className="font-heading text-2xl text-brand-green font-semibold">Informação legal</h1>

      {legal && (
        <div className="bg-white border border-brand-border rounded-2xl p-5 space-y-3" data-testid="legal-info-card">
          <div className="flex items-start gap-3">
            <IdentificationCard size={18} className="text-brand-green mt-0.5" />
            <div>
              <p className="text-sm text-brand-text" data-testid="legal-professional-name">{legal.professional_name}</p>
              <p className="text-xs text-brand-muted mt-1" data-testid="legal-cedula">Cédula profissional: {legal.cedula_profissional}</p>
              <p className="text-xs text-brand-muted" data-testid="legal-ers-clinic">ERS n.º {legal.ers_clinic}</p>
              {legal.ers_telemedicine && (
                <p className="text-xs text-brand-muted" data-testid="legal-ers-telemedicine">Registo ERS (telemedicina): {legal.ers_telemedicine}</p>
              )}
              {legal.nif && <p className="text-xs text-brand-muted" data-testid="legal-nif">NIF: {legal.nif}</p>}
              {legal.morada && <p className="text-xs text-brand-muted" data-testid="legal-morada">{legal.morada}</p>}
              {legal.telefone && <p className="text-xs text-brand-muted" data-testid="legal-telefone">Telefone: {legal.telefone}</p>}
            </div>
          </div>
        </div>
      )}

      <div className="bg-white border border-brand-border rounded-2xl p-4" data-testid="legal-links-card">
        <h3 className="font-heading font-medium text-xs text-brand-muted uppercase tracking-wider mb-3">Documentos e ligações</h3>
        <div className="space-y-1">
          <button onClick={() => navigate('/privacidade')} className="w-full text-left flex items-center gap-3 p-2 rounded-xl hover:bg-brand-bg transition-colors" data-testid="legal-privacy-link">
            <ShieldCheck size={18} className="text-brand-green" />
            <p className="text-sm text-brand-text">Política de Privacidade</p>
          </button>
          <button onClick={() => navigate('/termos-e-condicoes')} className="w-full text-left flex items-center gap-3 p-2 rounded-xl hover:bg-brand-bg transition-colors" data-testid="legal-terms-link">
            <FileText size={18} className="text-brand-green" />
            <p className="text-sm text-brand-text">Termos e Condições</p>
          </button>
          {legal && (
            <button onClick={() => window.open(legal.livro_reclamacoes_url, '_blank', 'noopener,noreferrer')} className="w-full text-left flex items-center gap-3 p-2 rounded-xl hover:bg-brand-bg transition-colors" data-testid="legal-reclamacoes-link">
              {legal.livro_reclamacoes_logo_path ? (
                <img src={imageUrl(legal.livro_reclamacoes_logo_path)} alt="Livro de Reclamações Eletrónico" className="h-6" />
              ) : (
                <Megaphone size={18} className="text-brand-green" />
              )}
              <p className="text-sm text-brand-text">Livro de Reclamações Eletrónico</p>
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
